// review.jsx
import React from "react";
import "../css/review.css";

// Import avatars from src/assets (bundler-friendly)
import r1 from "../assets/review1.jpg";
import r2 from "../assets/review2.jpg";
import r3 from "../assets/review3.jpg";

const reviews = [
  {
    id: 1,
    img: r1,
    name: "Rajesh Kumar",
    text:
      "The service was prompt and professional! Highly satisfied with the air conditioning repair.",
  },
  {
    id: 2,
    img: r2,
    name: "Anjali Desai",
    text:
      "JAY AMBE AC SERVICE provided excellent maintenance. My AC works perfectly now, thank you!",
  },
  {
    id: 3,
    img: r3,
    name: "Suresh Patel",
    text:
      "Their installation service was quick and efficient, ensuring our comfort in no time.",
  },
];

export default function Review() {
  return (
    <section className="reviews-section" aria-labelledby="reviews-heading">
      <div className="reviews-container">
        <p className="reviews-eyebrow">TESTIMONIALS</p>
        <h2 id="reviews-heading" className="reviews-title">
          Hear What Our Clients Say
        </h2>

        <div className="reviews-row" role="list">
          {reviews.map((r, idx) => (
            <article
              key={r.id}
              className={`review-card review-card-${idx + 1}`}
              role="listitem"
              tabIndex="0"
            >
              <div
                className="quote-icon"
                aria-hidden="true"
                dangerouslySetInnerHTML={{
                  __html: `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 7.5C9.5 6.11929 8.38071 5 7 5C5.61929 5 4.5 6.11929 4.5 7.5C4.5 9.98528 6.51472 12 9 12H9.5V7.5Z" fill="#3A79D9"/><path d="M20.5 7.5C20.5 6.11929 19.3807 5 18 5C16.6193 5 15.5 6.11929 15.5 7.5C15.5 9.98528 17.5147 12 20 12H20.5V7.5Z" fill="#3A79D9"/></svg>`,
                }}
              />

              <p className="review-text">{r.text}</p>

              <div className="review-author">
                <img src={r.img} alt={r.name} className="review-avatar" />
                <span className="review-name">{r.name}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
